module.exports = __webpack_public_path__ + "img/loader-white.20f5ebf6.svg";